module.exports = __webpack_public_path__ + "static/media/raindrop.a057af6a.png";